import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { getPlantData, getClimateData } from "../../store/design/actions"
import ReactApexChart from "react-apexcharts"
import { getAreas, updateArea, deleteArea, addArea } from "../../store/goals/actions"
import moment from 'moment';
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import Editable from 'react-x-editable'
import DatePicker from "react-datepicker"
import Spreadsheet from "react-spreadsheet";
import { useDrag, useDrop } from "react-dnd";
import GuildElement from "./guildelement"
import {
  Badge,
  Col,
  Collapse,
  CardHeader,
  Card,
  CardImg,
  CardImgOverlay,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Dropdown,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  TabContent,
  TabPane,
  Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"
import { Image } from '@aws-amplify/ui-react';
import { Storage } from '@aws-amplify/storage'


const GuildFunction = props => {
  const { plantMap, areaIndex, guildFunction, areas, setAreas, userareas, onUpdateArea } = props
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: "guildelement",
    collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
         hover: (item, monitor) => {
         },
         drop: (item) => {
            var srcArea = areas[item.area]
	    var plantIndex = srcArea.plants.indexOf(item.plant)
            areas[areaIndex].plants[plantIndex].guildFunction[0] = guildFunction
            onUpdateArea(areas[areaIndex])
            setAreas(areas)
         }
   }))

  return (
      <div ref={drop}>
        <Card outline color="secondary" className="border">
           <CardTitle>
	        {guildFunction}
	  </CardTitle>
	  <CardBody  style={{margin:"5px", padding:"2px", border:"2px"}} >
            {areas[areaIndex].plants.filter(plant => {
		    console.log("SDGSDFG");
              if (plant.guildFunction && plant.guildFunction[0]==guildFunction) {
                  return plant;
              }
          }).map((plant, pindex) => (
              <GuildElement plant={plant} plantIndex={pindex} areaIndex={areaIndex}/>
          ))}
	  </CardBody>
      </Card>
    </div>

   );
}
export default GuildFunction
